module.exports = __webpack_public_path__ + "img/71.b0f04a71.jpg";